import { PitPlaceholder } from "./PitPlaceholder";
import { containerEvents } from "../../ContainerEvents"
import { CREATE_ENTITIES, graphicEvents } from "../../GraphicEvents";

export class PitEditionMode {

    constructor() {
        this.pitPlaceholder = new PitPlaceholder();
    }

    onStartClick() {
        this.pitPlaceholder.start(containerEvents.mouseCoords);
    }

    onFinishClick() {
        const pit = this.pitPlaceholder.getStatement();
        this.pitPlaceholder.stop();

        if (pit.width < 15 || pit.height < 15) {
            alert('La fosse ne peut pas être créée puisqu\'elle est trop petite ! (< 15px)');
            return;
        } else if (!pit) {
            return;
        }

        graphicEvents.trigger(CREATE_ENTITIES, [pit]);
    }

    onCancelClick() {
        this.pitPlaceholder.stop();
    }

    onMoveMouse() {
        this.pitPlaceholder.move(containerEvents.mouseCoords);
    }

    destroy() {
        this.pitPlaceholder.destroy();
    }
}